module.exports = __webpack_public_path__ + "img/no-data.86ce5f98.png";